import React from "react";
import { AHIcon, AHText, Box, Circle, TouchableBox } from "arkh";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { StatusBar } from "expo-status-bar";
import { TimezoneIndicator } from "./TimezoneIndicator";

export const OrganisationHeaderHeight = 51;

export function OrganisationHeader(props: {
  storeName: string;
  navigateDeprecatedToOrg: () => void;
}) {
  const insets = useSafeAreaInsets();
  return (
    <>
      <StatusBar style="light" />
      <Box
        spaceLeft="xxsmall"
        spaceRight="medium"
        style={{
          backgroundColor: "#343437",
          justifyContent: "space-between",
          flexDirection: "row",
          alignItems: "center",
        }}
        insets={{ top: insets.top }}
      >
        <TouchableBox
          spaceHorizontal="small"
          onPress={() => props.navigateDeprecatedToOrg()}
          style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-start",
            height: OrganisationHeaderHeight,
          }}
        >
          <Circle
            size="smallMedium"
            color="positive"
            style={{
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(255,255,255,0.2)",
            }}
          >
            <AHIcon type="clear" size="small" color="text-inverted" />
          </Circle>
          <AHText spaceLeft="small" type="subtitle" color="text-inverted">
            {props.storeName}
          </AHText>
        </TouchableBox>
        <TimezoneIndicator />
      </Box>
    </>
  );
}
